/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import PriceField, { PriceFieldProps } from './PriceField'

function MaxPriceField (props: PriceFieldProps) {
  const { name = 'maxPrice', ...others } = props
  const intl = useIntl()
  return (
    <PriceField
      label={intl.formatMessage({
        id: 'max_price',
        defaultMessage: 'Prix maximal'
      })}
      name={name}
      {...others}
    />
  )
}

export default MaxPriceField
